export default "<router-outlet></router-outlet>\r\n<ngx-spinner type=\"ball-scale-multiple\"></ngx-spinner>\r\n"